<template>
  <TextField
    id="mealplan-key"
    :name="`${formNamespace}keystore.key`"
    :label="t('sites.singleSite.financialConfig.mealPlans.form.key')"
    :placeholder="t('sites.singleSite.financialConfig.mealPlans.form.keyPlaceholder')"
    :required="editMealPlan"
    :disabled="!editMealPlan"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { inject } from 'vue';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../routes';

// Set localization
const { t } = useI18n();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

const formNamespace = inject('formNamespace', '');
</script>
